import React, { ChangeEvent, useContext, useState } from "react";
import { convertTimetoString } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";
import Checkbox from "@mui/material/Checkbox";
import { NotAvailable } from "./styles";
import DocumentBar from "./DocumentBar";
import { JobHistoryDetails, RefereeData, CurrentEmployerDetails } from "./type";
import styles from "./css/styles.module.css";
import { ExNyRoute } from "../../../utils/allRouteId";
import apiCall from "../../../utils/apiCall";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from "../../../providers/notification";

interface WorkExperienceProps {
  workData?: JobHistoryDetails[];
  refreeData?: RefereeData[];
  referenceData?: RefereeData[];
  currentEmployerData?: CurrentEmployerDetails[];
  routeId: number;
}

interface Payload {
  id?: number;
  applicantId?: string;
  score: number;
}

const WorkExperience: React.FC<WorkExperienceProps> = ({
  routeId,
  workData = [],
  refreeData = [],
  referenceData = [],
  currentEmployerData = [],
}) => {
  const [id, setId] = useState<number | undefined>(0);
  const [score, setScore] = useState("");
  const [applicantId, setApplicantId] = useState<string | undefined>("");

  const { showNotification } = useContext(NotificationContext);
  const queryClient = useQueryClient();

  const handleScore = (event: ChangeEvent<HTMLInputElement>) => {
    setScore(event.target.value);
  };

  const handleCurrentEmployerDetails = (data?: CurrentEmployerDetails) => {
    setId(data?.Id);
    setApplicantId(data?.ApplicationId);
  };

  const url = `/Applicant/UpdateScorecurrentJobByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(
    score
  )}`;

  const updateEmploymentPromotionScore = async (payload: Payload) => {
    return await apiCall().post(url, payload);
  };

  const updateEmploymentPromotionScoreMutation = useMutation(
    ["update-promotion-score"],
    updateEmploymentPromotionScore
  );

  const updateEmploymentPromotionScoreHandler = async () => {
    const payload: Payload = {
      id,
      applicantId,
      score: Number(score),
    };

    try {
      await updateEmploymentPromotionScoreMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "Employment promotion score has been successfully updated",
          });
          queryClient.refetchQueries([
            "get-all-currentEmployer-details",
            applicantId,
          ]);
          queryClient.refetchQueries(["get-all-personal-details"]);
          queryClient.refetchQueries(["get-approval"]);

          setScore("");
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  return (
    <div className={`${css.edDiv} ${css.workD}`}>
      <p className={css.title}>Work Experience(s)</p>
      <div className={styles.headingBar}> WORK EXPERIENCE</div>
      <div style={{ overflowX: "auto" }}>
        {workData &&
        workData?.length &&
        workData?.length > 0 &&
        Array.isArray(workData) ? (
          <table>
            <tr className={styles.tableHead}>
              <th>Organization Name</th>
              <th>Position Held</th>
              <th>Current Job</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Organization Address</th>
            </tr>

            {workData &&
            workData?.length &&
            workData?.length > 0 &&
            Array.isArray(workData) ? (
              workData?.map((wData: JobHistoryDetails, index: number) => (
                <tr key={index}>
                  <td>{wData?.Organization || "N/A"}</td>
                  <td>{wData?.PositionHeld || "N/A"} </td>
                  <td
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginInlineStart: "-10px",
                    }}
                  >
                    <label>
                      <Checkbox disabled checked={wData?.IsCurrentJob} />
                    </label>
                    <span style={{ color: "#666666" }}></span>
                  </td>
                  <td>{convertTimetoString(wData?.StartDate, 2) || "N/A"}</td>

                  <td>
                    {" "}
                    {wData?.IsCurrentJob
                      ? "-"
                      : convertTimetoString(wData?.EndDate, 2) || "N/A"}
                  </td>
                  <td>{wData?.CompanyAddress || "N/A"}</td>
                </tr>
              ))
            ) : (
              <NotAvailable>Not Available</NotAvailable>
            )}
          </table>
        ) : (
          <NotAvailable>Not Available</NotAvailable>
        )}
      </div>
      
      {!(routeId == Number(ExNyRoute)) && (
        <>
          <div className={styles.headingBar}>
            CURRENT EMPLOYER INFORMATION(s)
          </div>
          <div style={{ overflowX: "auto" }}>
            {currentEmployerData.length > 0 ? (
              currentEmployerData.map((eData: CurrentEmployerDetails) => (
                <div key={eData?.ApplicationId} className={css.curEmpDet}>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Present Employer name
                    </span>
                    <br />
                    {eData?.PrensentEmployer || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Employer Address</span>
                    <br />
                    {eData?.EmployerAddress || "N/A"}
                  </div>
                  {eData?.Sector == "OTHERS" ? (
                    <div className={css.curEmpHeader1}>
                      <span className={css.curEmpHeader}>Sector</span>
                      <br />
                      {eData?.OtherSector || "N/A"}{" "}
                    </div>
                  ) : (
                    <div className={css.curEmpHeader1}>
                      <span className={css.curEmpHeader}>Sector</span>
                      <br />
                      {eData?.Sector || "N/A"}{" "}
                    </div>
                  )}
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Job Title</span>
                    <br />
                    {eData?.PresentDuty || "N/A"}{" "}
                  </div>
                  {/* <EachPersonalField label="Grade Level" value={eData?.ApplicantGradeLevel || 'N/A'} /> */}
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Grade Level</span>
                    <br />
                    {eData?.ApplicantGradeLevel === "Others"
                      ? eData?.OtherApplicantGradeLevel
                      : eData?.ApplicantGradeLevel}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Date of Appointment
                    </span>
                    <br />
                    {convertTimetoString(eData?.AppointmentDate, 2) || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Total Employees</span>
                    <br />
                    {eData?.TotalNumberOfEmployees || "N/A"}{" "}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      No of Senior Employees
                    </span>
                    <br />
                    {eData?.NoOfSeniorEmployees || "N/A"}{" "}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      No of Junior Employees
                    </span>
                    <br />
                    {eData?.NoOfJuniorEmployees || "N/A"}{" "}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Last Year's Revenue/Turnover
                    </span>
                    <br />
                    {eData?.LastYearRevenue || "N/A"}{" "}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Present Duties Scope
                    </span>
                    <br />
                    {eData?.PresentDuty || "N/A"}{" "}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <DocumentBar
                      hideScoreIntegration
                      docName={`Evidence Of Promotion/Appointment`}
                      documentUrl={eData?.UploadDocument}
                      onChange={handleScore}
                      score={score}
                      displayScore={eData?.Score}
                      handleVisibility={() =>
                        handleCurrentEmployerDetails(eData)
                      }
                      handleSubmit={updateEmploymentPromotionScoreHandler}
                      loading={
                        updateEmploymentPromotionScoreMutation?.isLoading
                      }
                    />
                  </div>
                </div>
              ))
            ) : (
              <NotAvailable>Not Available</NotAvailable>
            )}
          </div>

          <div className={styles.headingBar}>REFEREE </div>
          <div style={{ overflowX: "auto" }}>
            {refreeData?.length > 0 && routeId !== 4 && (
              <table>
                <tr className={styles.tableHead}>
                  <th className={css.curEmpHeader}>Full name</th>
                  <th className={css.curEmpHeader}>Email Address</th>
                  <th className={css.curEmpHeader}>Phone Number</th>
                  <th className={css.curEmpHeader}>Designation</th>
                  <th className={css.curEmpHeader}>Business Address</th>
                  <th className={css.curEmpHeader}>Uploaded Document</th>
                </tr>

                {refreeData?.length > 0 &&
                  refreeData?.map((eR: RefereeData, index: number) => (
                    <tr key={index}>
                      <td>{eR?.FullName || "N/A"}</td>
                      <td>{eR?.Email || "N/A"}</td>
                      <td>{eR?.PhoneNumber || "N/A"} </td>
                      <td>{eR?.Designation || "N/A"} </td>
                      <td>{eR?.BusinessAddress || "N/A"} </td>
                      <td>
                        <DocumentBar
                          hideScoreIntegration={false}
                          docName={`REFEREE DOCUMENT`}
                          documentUrl={eR?.RefereeLetterUrl}
                          onChange={() => {}}
                        />
                      </td>
                    </tr>
                  ))}
              </table>
            )}

            {referenceData?.length > 0 && routeId === 4 && (
              <></>
            )}
            
            {refreeData?.length === 0 && routeId !== 0 && (
              <NotAvailable>Not Available</NotAvailable>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WorkExperience;
